import { InfoField } from '@occc/ui-design-system';
import { ConstraintFragment } from '@occc/graphql';
import { getConstraintsByType } from '../constraints-section.utils';
import { formatYesNoValues } from '../../formatters';

export const EmailRequiredConstraint = ({ constraints }: { constraints: ConstraintFragment[] }) => {
  const cst = getConstraintsByType('ConstraintEmailRequired', constraints);

  return <InfoField label='Email Required' value={formatYesNoValues(cst)} />;
};
